export default __webpack_public_path__ + "static/media/_dkg_brust_nrw.850d1a61.svg";